import Head from 'next/head';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { COMMON_PATHS, CORPORATION_PATHS, INDIVIDUAL_PATHS, 환급결정확인알림톡_PATH } from '@/lib/constants/paths';

const TaxRefundTestPage = () => {
  const router = useRouter();

  return (
    <div className="page-padding flex w-full flex-col pb-[6.75rem]">
      <Head>
        <title>새로운 경정청구 테스트 페이지</title>
        <meta property="og:title" content="경정청구 테스트 페이지" key="title" />
      </Head>
      <h1>경정청구 테스트 페이지</h1>

      <br />

      <h2>공통</h2>
      <ul className="page-padding list-disc">
        <li>
          <Link
            href={{
              pathname: `${COMMON_PATHS.환급조회목록}`,
              query: router?.query
            }}
          >
            환급 조회 목록 페이지로 이동
          </Link>
        </li>
      </ul>

      <br />

      <h2>개인사업자</h2>
      <ul className="page-padding list-disc">
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인조회방법선택}`,
              query: router?.query
            }}
          >
            개인 사업자 조회 방법 선택 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인공동인증서프로그램설치판단}`,
              query: router?.query
            }}
          >
            개인 사업자 공동인증 설치 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인공동인증서선택}`,
              query: router?.query
            }}
          >
            개인 사업자 공동인증 선택 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인수집및조회}`,
              query: { ...router?.query, type: 'indis' }
            }}
          >
            개인 사업자 수집 및 조회 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인환급액조회결과}`,
              query: { ...router?.query, type: 'indis' }
            }}
          >
            개인 사업자 조회 완료 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${COMMON_PATHS.환급계좌입력}`,
              query: router?.query
            }}
          >
            개인 사업자 계좌번호 입력 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${COMMON_PATHS.환급본인휴대폰번호입력}`,
              query: router?.query
            }}
          >
            개인 사업자 휴대폰 번호 입력 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${COMMON_PATHS.환급신청완료}`,
              query: { ...router?.query, type: 'indis' }
            }}
          >
            개인 사업자 신청 완료 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${COMMON_PATHS.환급신청결과}`,
              query: { ...router?.query, type: 'indis' }
            }}
          >
            개인 사업자 신청 결과 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인기타오류}`,
              query: router?.query
            }}
          >
            개인 사업자 조회시 기타 에러 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인홈택스이용불가시간}`,
              query: router?.query
            }}
          >
            개인 사업자 조회시 홈택스 이용불가 시간 에러 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인홈택스점검중}`,
              query: router?.query
            }}
          >
            개인 사업자 조회시 홈택스 점검중 에러 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인재로그인유도}`,
              query: router?.query
            }}
          >
            개인 사업자 조회시 홈택스 세선만료 에러 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인홈택스수집지연}`,
              query: router?.query
            }}
          >
            개인 사업자 조회시 홈택스 수집지연 에러 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인일시적인오류}}`,
              query: router?.query
            }}
          >
            개인 사업자 조회시 일시적인 오류 에러 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인취소방어}`,
              query: router?.query
            }}
          >
            개인 사업자 취소방어 컨텐츠 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${INDIVIDUAL_PATHS.개인취소사유}`,
              query: router?.query
            }}
          >
            개인 사업자 취소사유선택 페이지로 이동
          </Link>
        </li>
      </ul>

      <br />

      <h2>법인사업자</h2>
      <ul className="page-padding list-disc">
        <li>
          <Link
            href={{
              pathname: `${CORPORATION_PATHS.법인조회방법선택}`,
              query: router?.query
            }}
          >
            법인 사업자 조회 방법 선택 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${CORPORATION_PATHS.홈택스아이디입력}`,
              query: router?.query
            }}
          >
            법인 사업자 홈택스 아이디 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${CORPORATION_PATHS.법인공동인증서프로그램설치판단}`,
              query: router?.query
            }}
          >
            법인 사업자 공동인증서 프로그램 설치 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${CORPORATION_PATHS.법인공동인증서선택}`,
              query: router?.query
            }}
          >
            법인 사업자 공동인증서 선택 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${COMMON_PATHS.환급신청결과}`,
              query: { ...router?.query, type: 'corps' }
            }}
          >
            법인 사업자 환급 신청 결과
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${CORPORATION_PATHS.법인수집및조회}`,
              query: { ...router?.query, type: 'corps' }
            }}
          >
            법인 사업자 수집 페이지로 이동
          </Link>
          <ul className="page-padding list-disc">
            <li>
              <Link
                href={{
                  pathname: `${CORPORATION_PATHS.법인홈택스이용불가시간}`,
                  query: router?.query
                }}
              >
                홈택스 이용불가시간 에러 페이지로 이동
              </Link>
            </li>
            <li>
              <Link
                href={{
                  pathname: `${CORPORATION_PATHS.법인홈택스점검중}`,
                  query: router?.query
                }}
              >
                홈택스 점검중 에러 페이지로 이동
              </Link>
            </li>
            <li>
              <Link
                href={{
                  pathname: `${CORPORATION_PATHS.법인재로그인유도}`,
                  query: router?.query
                }}
              >
                홈택스 재로그인 유도 에러 페이지로 이동
              </Link>
            </li>
            <li>
              <Link
                href={{
                  pathname: `${CORPORATION_PATHS.법인홈택스수집지연}`,
                  query: router?.query
                }}
              >
                홈택스 수집지연 에러 페이지로 이동
              </Link>
            </li>
            <li>
              <Link
                href={{
                  pathname: `${CORPORATION_PATHS.법인일시적인오류}`,
                  query: router?.query
                }}
              >
                일시적인 오류 에러 페이지로 이동
              </Link>
            </li>
            <li>
              <Link
                href={{
                  pathname: `${CORPORATION_PATHS.법인기타오류}`,
                  query: router?.query
                }}
              >
                기타 오류 에러 페이지로 이동
              </Link>
            </li>
          </ul>
        </li>
        <li>
          <Link
            href={{
              pathname: `${CORPORATION_PATHS.법인환급액조회결과}`,
              query: { ...router?.query, type: 'corps' }
            }}
          >
            법인 사업자 환급액 조회 결과 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${COMMON_PATHS.환급계좌입력}`,
              query: router?.query
            }}
          >
            법인 사업자 계좌번호 입력 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${COMMON_PATHS.환급본인휴대폰번호입력}`,
              query: router?.query
            }}
          >
            법인 사업자 전화번호 입력 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${COMMON_PATHS.환급신청완료}`,
              query: { ...router?.query, type: 'corps' }
            }}
          >
            법인 사업자 신청 완료 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${CORPORATION_PATHS.법인취소방어}`,
              query: router?.query
            }}
          >
            법인 사업자 취소 방어 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${CORPORATION_PATHS.법인취소사유}`,
              query: router?.query
            }}
          >
            법인 사업자 취소 사유 선택 페이지로 이동
          </Link>
        </li>
      </ul>

      <br />

      <h2>환급결정확인 알림톡</h2>
      <ul className="page-padding list-disc">
        <li>
          <Link
            href={{
              pathname: `${환급결정확인알림톡_PATH.환급불가}`,
              query: router?.query
            }}
          >
            환급불가 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${환급결정확인알림톡_PATH.환급결정내역있음}`,
              query: router?.query
            }}
          >
            환급결정내역있음 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${환급결정확인알림톡_PATH.환급결정내역없음}`,
              query: router?.query
            }}
          >
            환급결정내역없음 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${환급결정확인알림톡_PATH.공동인증서설치판단}`,
              query: router?.query
            }}
          >
            공동인증서프로그램 설치 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${환급결정확인알림톡_PATH.공동인증서선택}`,
              query: router?.query
            }}
          >
            공동인증서 선택 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${환급결정확인알림톡_PATH.결정확인방법선택}`,
              query: router?.query
            }}
          >
            결정확인방법 선택 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${환급결정확인알림톡_PATH.환급결정로딩}`,
              query: router?.query
            }}
          >
            결정확인 조회 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${환급결정확인알림톡_PATH.환급결정로딩에러기타}`,
              query: router?.query
            }}
          >
            결정확인 조회 기타 에러 페이지로 이동
          </Link>
        </li>
        <li>
          <Link
            href={{
              pathname: `${환급결정확인알림톡_PATH.환급결정로딩에러TIN비일치}`,
              query: router?.query
            }}
          >
            결정확인 조회 TIN 비일치 에러 페이지로 이동
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default TaxRefundTestPage;
